// API client para o proxy do Chatbot (fuinil-app)
export default {
  getFunnels(accountId) {
    return window.axios.get(`/api/v1/accounts/${accountId}/chatbot/funnels`);
  },
  saveFunnels(accountId, payload) {
    return window.axios.post(`/api/v1/accounts/${accountId}/chatbot/funnels`, payload);
  },
  simulate(accountId, payload) {
    return window.axios.post(`/api/v1/accounts/${accountId}/chatbot/simulate`, payload);
  },
  upload(accountId, payload) {
    return window.axios.post(`/api/v1/accounts/${accountId}/chatbot/upload`, payload);
  }
};
